import { status } from "@otto-ec/global-resources/debug";

export class Logger {
    /*                          */

    static group(title: string) {
        if (status().activated) {
            if (console.group) {
                console.group(title);
            }
        }
    }

    static groupEnd() {
        if (status().activated) {
            if (console.groupEnd) {
                console.groupEnd();
            }
        }
    }

    static log(msg: string) {
        if (status().activated) {
            console.log(msg);
        }
    }

    static warn(msg: string) {
        if (console.warn && status().activated) {
            console.warn(msg);
        }
    }

    static count(label: string) {
        if (status().activated) {
            if (console.count) console.count(label);
        }
    }

}